export default "__VITE_ASSET__Ct$gY9SM__"